export default __webpack_public_path__ + "static/media/close-circle.bb68fb65.svg";